// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"_11JYmGdnjyK-87T1hh2-d7","isFirstRow":"_1Ob4u0a8s6G761-fg7dTpQ","title":"JdiOTOZlYBtG2JeGCIA6b","body":"_285V_e_gA2HV-lyujIyLQh"};